import React from 'react';
import Select from 'react-select';
import countryStdCodes from '../data/countryStdCodes';

const ShippingForm = ({ formData, setFormData, onChangeHandler }) => {
  const indianStates = [
    'Andhra Pradesh',
    'Arunachal Pradesh',
    'Assam',
    'Bihar',
    'Chhattisgarh',
    'Goa',
    'Gujarat',
    'Haryana',
    'Himachal Pradesh',
    'Jharkhand',
    'Karnataka',
    'Kerala',
    'Madhya Pradesh',
    'Maharashtra',
    'Manipur',
    'Meghalaya',
    'Mizoram',
    'Nagaland',
    'Odisha',
    'Punjab',
    'Rajasthan',
    'Sikkim',
    'Tamil Nadu',
    'Telangana',
    'Tripura',
    'Uttar Pradesh',
    'Uttarakhand',
    'West Bengal',
    'Andaman and Nicobar Islands',
    'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi',
    'Jammu and Kashmir',
    'Ladakh',
    'Lakshadweep',
    'Puducherry',
  ];

  const countryOptions = countryStdCodes.map((c) => ({
    value: c.country,
    label: c.country,
  }));

  const stateOptions = indianStates.map((state) => ({
    value: state,
    label: state,
  }));

  const selectStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: 400,
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#67000b' : '#d1d5db',
      boxShadow: state.isFocused ? '0 0 0 1px #67000b' : 'none',
      '&:hover': {
        borderColor: '#67000b',
      },
      borderRadius: '0.375rem',
      padding: '2px 4px',
      minHeight: '44px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#fdf0f0' : state.isSelected ? '#67000b' : undefined,
      color: state.isSelected ? '#ffffff' : '#333333',
      '&:active': {
        backgroundColor: '#c06a6f',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#333333',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#999999',
    }),
  };

  const handleCountryChange = (selectedOption) => {
    const selectedCountry = selectedOption.value;
    const selectedStd = countryStdCodes.find((c) => c.country === selectedCountry)?.std || '';

    // First update country using onChangeHandler
    onChangeHandler({
      target: {
        name: 'country',
        value: selectedCountry,
      },
    });

    // Then update phone prefix
    setFormData((prev) => ({
      ...prev,
      phone: selectedStd ? selectedStd + ' ' : '',
      state: '', // reset state when country changes
    }));
  };

  const handleStateChange = (selectedOption) => {
    const selectedState = selectedOption.value;

    onChangeHandler({
      target: {
        name: 'state',
        value: selectedState,
      },
    });
  };

  return (
    <div className="flex flex-col gap-3">
      {/* Name Fields */}
      <div className="flex gap-3">
        <input
          required
          onChange={onChangeHandler}
          name="firstName"
          value={formData.firstName}
          className="border border-gray-300 rounded py-2 px-4 w-full"
          type="text"
          placeholder="First name"
        />
        <input
          required
          onChange={onChangeHandler}
          name="lastName"
          value={formData.lastName}
          className="border border-gray-300 rounded py-2 px-4 w-full"
          type="text"
          placeholder="Last name"
        />
      </div>

      {/* Email */}
      <input
        required
        onChange={onChangeHandler}
        name="email"
        value={formData.email}
        className="border border-gray-300 rounded py-2 px-4 w-full"
        type="email"
        placeholder="Email Address"
      />

      {/* Street */}
      <input
        required
        onChange={onChangeHandler}
        name="street"
        value={formData.street}
        className="border border-gray-300 rounded py-2 px-4 w-full"
        type="text"
        placeholder="Street"
      />

      {/* City & Country */}
      <div className="grid grid-cols-2 gap-3">
        <input
          required
          onChange={onChangeHandler}
          name="city"
          value={formData.city}
          className="border border-gray-300 rounded py-2 px-4 w-full"
          type="text"
          placeholder="City"
        />

        <Select
          options={countryOptions}
          onChange={handleCountryChange}
          value={countryOptions.find((option) => option.value === formData.country) || null}
          placeholder="Country"
          className="w-full"
          styles={selectStyles}
          isSearchable
        />
      </div>

      {/* Other Country Input */}
      {formData.country === 'Other' && (
        <input
          required
          type="text"
          name="otherCountry"
          value={formData.otherCountry || ''}
          onChange={onChangeHandler}
          className="border border-gray-300 rounded py-2 px-4 w-full text-black"
          placeholder="Country"
        />
      )}

      {/* State & Zipcode */}
      <div className="grid grid-cols-2 gap-3">
        {formData.country === 'India' ? (
          <Select
            options={stateOptions}
            onChange={handleStateChange}
            value={stateOptions.find((option) => option.value === formData.state) || null}
            placeholder="State"
            className="w-full"
            styles={selectStyles}
            isSearchable
          />
        ) : (
          <input
            required
            onChange={onChangeHandler}
            name="state"
            value={formData.state}
            className="border border-gray-300 rounded py-2 px-4 w-full"
            type="text"
            placeholder="State"
          />
        )}

        <input
          required
          onChange={onChangeHandler}
          name="zipcode"
          value={formData.zipcode}
          className="border border-gray-300 rounded py-2 px-4 w-full"
          type="number"
          placeholder="Zipcode"
        />
      </div>

      {/* Phone */}
      <input
        required
        onChange={onChangeHandler}
        name="phone"
        value={formData.phone}
        className="border border-gray-300 rounded py-2 px-4 w-full"
        type="tel"
        placeholder={
          formData.country
            ? `${
                countryStdCodes.find((c) => c.country === formData.country)?.std || ''
              } Phone number`
            : 'Phone number'
        }
        title="Please enter a valid phone number with country code"
      />
    </div>
  );
};

export default ShippingForm;
